<template>
  <PlaceholderWrapper
    :is-loading="isLoading"
    :is-empty="isEmpty"
    :empty-message="$t('messages.information.no_notification')"
    empty-icon="mdi-bell-outline"
    :empty-height="250"
    :empty-icon-size="60"
  >
    <template v-slot:content>
      <div>
        <slot name="actions" />
        <v-card class="mt-4 rounded-xl">
          <v-card-text>
            <NotificationDatatable
              :dense="dense"
              :items="notifications"
              @click="handleClick"
            />
          </v-card-text>
        </v-card>
      </div>
    </template>
  </PlaceholderWrapper>
</template>

<script>
import PlaceholderWrapper from "@/components/base/PlaceholderWrapper.vue"
import NotificationDatatable from "@/components/ri3/notifications/NotificationDatatable.vue"

export default {
  name: "NotificationWrapper",
  components: {
    NotificationDatatable,
    PlaceholderWrapper
  },
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    isEmpty() {
      return this.items.length <= 0
    },
    items() {
      let rawNotifications = this.$store.state.app.notifications
      this.$emit("notificationsLength", rawNotifications.count)
      return rawNotifications.map(e => {
        return {
          id: e.id,
          icon: this.getIcon(e.target.type),
          object: e.target.type,
          company: e.target.company,
          project: e.target.project.name,
          name: e.target.name,
          datetime: e.target.date,
          info: e.target.info,
          read: e.read,
          target: e.target
        }
      })
    },
    notifications() {
      return (
        this.maxLength > 0 && this.items.length >= this.maxLength
          ? this.items.slice(0, this.maxLength)
          : this.items
      ).filter(e => e.target)
    }
  },
  mounted() {
    this.isLoading = true
    this.fetchNotifications().finally(() => {
      this.isLoading = false
    })
  },
  beforeDestroy() {
    this.updateNotifications()
  },
  methods: {
    getIcon(type) {
      if (type === "Inspection") {
        return "mdi-magnify"
      } else if (type === "Project") {
        return "mdi-airplane-takeoff"
      } else if (type === "Task") {
        return "mdi-clock-start"
      } else if (type === "NonConformity") {
        return "mdi-clipboard-alert-outline"
      } else if (type === "NCAction") {
        return "mdi-gesture-tap"
      } else {
        return ""
      }
    },
    async fetchNotifications() {
      return this.$store.dispatch("app/fetchNotifications")
    },
    async updateNotifications() {
      return this.$store.dispatch("app/updateNotifications")
    },
    setStore(item) {
      this.$store.commit("app/setProject", item.target.project)
      this.$store.commit("app/setCompany", item.target.project.company)
    },
    handleClick(item) {
      if (item.object === "Project") {
        this.setStore(item)
        this.$router.push({
          path: `/projects/${item.target.id}/editor`,
          query: { chosenTab: 1 }
        })
      } else if (item.object === "Task") {
        this.setStore(item)
        this.$router.push({
          path: `/projects/${item.target.project.id}/editor`,
          query: { chosenTab: 2 }
        })
      } else if (item.object === "Inspection") {
        this.setStore(item)
        this.$router.push({
          path: `/project/inspections/${item.target.id}`
        })
      } else if (item.object === "NonConformity") {
        this.setStore(item)
        this.$router.push({
          path: `/project/non-conformities/${item.target.id}/editor`
        })
      }
    }
  }
}
</script>
